// The time-zone offset is the difference, in hours, between local time and UTC
// This means that the offset is positive if the local timezone is behind UTC and negative if it is ahead
export function getTimezoneOffset(date)
{
    date = date ?? new Date();
    const timezoneOffset = date.getTimezoneOffset();
    return Math.round(-timezoneOffset / 60);
}